import { color } from '@/colors';

/** Matches Canvas “Replace missing fonts” modal (Figma node 6014:20663). */
export const modalOutline = `1px solid ${color.White04_T}`;

export const tableGridColumns = '160px 16px minmax(0, 1fr) 16px' as const;

export const rowGrid = {
  display: 'grid',
  gridTemplateColumns: tableGridColumns,
  alignItems: 'center',
  columnGap: 2,
} as const;

export const dropdownTriggerSx = {
  minHeight: 24,
  height: 24,
  boxSizing: 'border-box',
  borderColor: `${color.White16_T} !important`,
} as const;
